import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { useContext, useEffect, useState } from 'react'
import { WebSocketContext } from '../../Providers/WebSocket/WebSocketContext'
import { CondominiosContext } from '../../Providers/CondominiosContext/CondominiosContext'
import { showNotify } from '../../Utils/Utils'
import { Button, Typography } from '@mui/material'
import OcorrenciaDados from './OcorrenciaDados/OcorrenciaDados'
import OcorrenciaModal from './OcorrenciaModal/OcorrenciaModal'
import OneSelect from '../../Components/OneSelect/OneSelect'
import OneInput from '../../Components/OneInput/OneInput'
import CardsFilters from './CardsFilters/CardsFilters'
import { EventosContext } from '../../Providers/EventosContext/EventosContext'
import { AtalhosContext } from '../../Providers/AtalhosContext/AtalhosContext'

const OcorrenciasPage = () => {
    const [ocorrencias, setOcorrencias] = useState([])
    const { sendWs, addRoute } = useContext(WebSocketContext)
    const { activeCond } = useContext(CondominiosContext)
    const { eventoSelecionado } = useContext(EventosContext)
    const { criarAtalho, removerAtalho } = useContext(AtalhosContext)

    const [openOcorrencia, setOpenOcorrencia] = useState(false)
    const [ocorrencia, setOcorrencia] = useState({})

    const [cardsFilters, setCardsFilters] = useState(null)

    const [filtros, setFiltros] = useState({
        dataInicio: '',
        dataFim: '',
        id_status: 'Todos'
    })

    const abrirModalOcorrencia = (ocorrencia) => {
        setOcorrencia(ocorrencia)
        setOpenOcorrencia(true)
    }

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFiltros({ ...filtros, [event.target.name]: event.target.checked })
            } else {
                setFiltros({ ...filtros, [event.target.name]: event.target.value })
            }
        }
    }

    useEffect(() => {
        addRoute('buscarOcorrencias', (msg) => {
            if (msg.data.status) {
                setCardsFilters(msg.data.listaOcorrencias.countFilters)
                setOcorrencias(msg.data.listaOcorrencias.dados)

                if (eventoSelecionado.evento == 'OCAP') {
                    let listaOcorrencias = msg.data.listaOcorrencias.dados
                    if (listaOcorrencias.length > 0) {
                        let ocorrenciaSelecionada = listaOcorrencias.filter((oc) => oc.id == eventoSelecionado.serial)

                        if (ocorrenciaSelecionada.length > 0) {
                            abrirModalOcorrencia(ocorrenciaSelecionada[0])
                        }
                    }
                }
            } else {
                showNotify('Erro', msg.data.message)
            }
        })
        sendWs('buscarOcorrencias', { filtros: { id_central: activeCond.id_central } })
        criarAtalho('f', () => {
            sendWs('buscarOcorrencias', { filtros: { id_central: activeCond.id_central } })
        })
        return () => {
            removerAtalho('f')
        }
    }, [activeCond.id_central])

    const filtrar = () => {
        if (filtros.id_status == 'Todos') delete filtros.id_status
        if (filtros.dataInicio == '') delete filtros.dataInicio
        if (filtros.dataFim == '') delete filtros.dataFim
        sendWs('buscarOcorrencias', { filtros: { ...filtros, id_central: activeCond.id_central } })
    }
    return (
        <Grid xs={12} item container
            sx={{
                height: '100%',
                width: '100%',
                backgroundColor: '#D9D9D9',
                padding: '5px',
                display: 'flex',
                flexDirection: 'row',
                alignContent: 'flex-start',
                justifyContent: 'flex-start',
                overflow: 'hidden'
            }}
            gap={0.5}
        >
            {openOcorrencia &&
                <OcorrenciaModal
                    openOcorrencia={openOcorrencia}
                    setOpenOcorrencia={setOpenOcorrencia}
                    ocorrencia={ocorrencia}
                />
            }
            {cardsFilters &&
                <Grid item container xs={12} sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    gap: 1,
                    height: '10%'
                }}>
                    <CardsFilters cor="#E16C57" titulo="Abertos" valor={cardsFilters.aberto} />
                    <CardsFilters cor="#FFC11C" titulo="Em Andamento" valor={cardsFilters.andamento} />
                    <CardsFilters cor="#179F62" titulo="Finalizados" valor={cardsFilters.finalizado} />
                </Grid>
            }
            <Grid item conteiner xs={12} sx={{
                height: {
                    xl: '60px',
                    lg: '100px'
                },
                display: 'flex',
                flexDirection: 'row'
            }}>
                <Grid item container lg={3} sx={{
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Grid item container lg={12} xl={4} sx={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Typography>Data Inicial</Typography>
                    </Grid>
                    <Grid item container lg={7} sx={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <OneInput
                            type="date"
                            name="dataInicio"
                            onChange={handleChange}
                            newSx={{
                                width: '100%',
                                input: {
                                    height: { xs: '30px', lg: '21px', xl: '30px' },
                                    fontSize: { lg: '10px', xl: '15px' }
                                },
                                label: {
                                    fontSize: { lg: '13px', xl: '15px' }
                                }
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid item container lg={3} sx={{
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Grid item container lg={12} xl={4} sx={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Typography>Data Final</Typography>
                    </Grid>
                    <Grid item container lg={7} sx={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <OneInput
                            type="date"
                            name="dataFim"
                            onChange={handleChange}
                            newSx={{
                                width: '100%',
                                input: {
                                    height: { xs: '30px', lg: '21px', xl: '30px' },
                                    fontSize: { lg: '10px', xl: '15px' }
                                },
                                label: {
                                    fontSize: { lg: '13px', xl: '15px' }
                                }
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid item container lg={3} sx={{
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Grid item container lg={12} xl={4} sx={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Typography>Status</Typography>
                    </Grid>
                    <Grid item container lg={7} sx={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <OneSelect
                            options={[{ id: 'Todos', descricao: 'Todos' }, { id: '0', descricao: 'Aberto' }, { id: 1, descricao: 'Em Andamento' }, { id: 2, descricao: 'Finalizado' }]}
                            defaultValue={'Todos'}
                            name="id_status"
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>
                <Grid item container lg sx={{
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Button
                        color={'one_primary'}
                        variant="contained"
                        onClick={() => filtrar()}
                        sx={{ width: '100px', height: '30px' }}
                    >
                            Filtrar
                    </Button>
                </Grid>
            </Grid>
            <Grid item container xs={12} sx={{
                overflowY: 'auto',
                display: 'flex',
                alignContent: 'flex-start',
                justifyContent: 'center',
                flexDirection: 'row',
                gap: 1,
                maxHeight: {
                    xl: 'calc(100% - 60px)',
                    lg: 'calc(100% - 100px)'
                },
                paddingRight: '5px'
            }}>
                {ocorrencias && ocorrencias.length > 0
                    ? ocorrencias.map((ocorrencia, index) => {
                        return (
                            <OcorrenciaDados key={index} ocorrencia={ocorrencia} abrirModalOcorrencia={abrirModalOcorrencia}/>
                        )
                    })
                    : <Typography variant="h6">Nenhuma ocorrência encontrada</Typography>
                }
            </Grid>
        </Grid>
    )
}

export default OcorrenciasPage
